<template>
  <div class="ev-add-wrap">
    <AError :api="apiSubmit" />

    <!-- Alert Banner -->
    <AAlertBanner variant="danger" :messages="alertError" title="Warning" />

    <!-- Confirm Dialog -->
    <v-dialog v-model="eventDialog" max-width="380" content-class="confirm-dialog">
      <div class="confirm-card">
        <h3 class="confirm-card__title">{{ model.add.name }}</h3>
        <p class="confirm-card__message">Please confirm that you wish to Add New {{ model.add.name }}?</p>
        <div class="confirm-card__actions">
          <button class="confirm-card__btn confirm-card__btn--cancel" @click="eventDialog = false">
            Cancel
          </button>
          <button class="confirm-card__btn confirm-card__btn--confirm" @click="addNewEvent()">
            Confirm
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Sub-Header with Back -->
    <div class="ev-sub-header">
      <div class="ev-sub-header__left">
        <button class="ev-back-btn" @click="toggleEventPage()">
          <v-icon size="16" color="var(--app-text-muted)">mdi-arrow-left</v-icon>
        </button>
        <h2 class="ev-sub-header__title">Add {{ model.view.name }}</h2>
      </div>
    </div>

    <!-- Form Card -->
    <div class="ev-form-card">
      <div class="ev-form-card__section-label">
        <v-icon size="16" color="var(--app-accent)" class="mr-2">mdi-calendar-edit</v-icon>
        Event Details
      </div>
      <div class="ev-form-card__divider"></div>

      <div class="ev-form-card__body">
        <!-- Title -->
        <div class="ev-form-group">
          <label class="ev-form-group__label">Title</label>
          <v-text-field
            dense
            outlined
            placeholder="e.g. E-INVOICING CONFERENCE"
            v-model="formData.title"
            :error-messages="errorField.title"
            hide-details="auto"
            class="ev-form-input"
          ></v-text-field>
        </div>

        <!-- Venue Address -->
        <div class="ev-form-group">
          <label class="ev-form-group__label">Venue Address</label>
          <v-textarea
            dense
            outlined
            auto-grow
            rows="2"
            placeholder="Enter venue address"
            v-model="formData.venueAddress"
            :error-messages="errorField.venueAddress"
            hide-details="auto"
            class="ev-form-input"
          ></v-textarea>
        </div>

        <!-- Speakers & Category Row -->
        <div class="ev-form-row-2col">
          <div class="ev-form-group">
            <label class="ev-form-group__label">Event Speakers</label>
            <v-select
              dense
              outlined
              v-model="formData.speakers"
              :error-messages="errorField.speakers"
              :items="speakers"
              placeholder="Select speakers"
              multiple
              chips
              small-chips
              :menu-props="{
                bottom: true,
                offsetY: true,
              }"
              hide-details="auto"
              class="ev-form-input"
            ></v-select>
          </div>

          <div class="ev-form-group">
            <label class="ev-form-group__label">Event Category</label>
            <v-select
              dense
              outlined
              v-model="formData.eventCategory"
              :error-messages="errorField.eventCategory"
              :items="eventCategoriesData"
              placeholder="Select category"
              :menu-props="{
                bottom: true,
                offsetY: true,
              }"
              hide-details="auto"
              class="ev-form-input"
            ></v-select>
          </div>
        </div>

        <!-- Date Row -->
        <div class="ev-form-row-2col">
          <div class="ev-form-group">
            <label class="ev-form-group__label">Event Start Date</label>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="date1"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  outlined
                  v-model="formData.eventStartDate"
                  :error-messages="errorField.eventStartDate"
                  placeholder="YYYY-MM-DD"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details="auto"
                  class="ev-form-input"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.eventStartDate"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu1.save(date1)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>

          <div class="ev-form-group">
            <label class="ev-form-group__label">Event End Date</label>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date2"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  outlined
                  v-model="formData.eventEndDate"
                  :error-messages="errorField.eventEndDate"
                  placeholder="YYYY-MM-DD"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details="auto"
                  class="ev-form-input"
                ></v-text-field>
              </template>
              <v-date-picker v-model="formData.eventEndDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu2 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu2.save(date2)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>

        <!-- Grant Application Deadline Row -->
        <div class="ev-form-row-2col">
          <div class="ev-form-group">
            <label class="ev-form-group__label">Event Grant Application Deadline</label>
            <v-menu
              ref="menu3"
              v-model="menu3"
              :close-on-content-click="false"
              :return-value.sync="date3"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  outlined
                  v-model="formData.grantApplicationDeadlineDate"
                  :error-messages="errorField.grantApplicationDeadlineDate"
                  placeholder="YYYY-MM-DD"
                  prepend-inner-icon="mdi-calendar"
                  clearable
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details="auto"
                  class="ev-form-input"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.grantApplicationDeadlineDate"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu3 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu3.save(date3)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>

        <!-- Language & Status Row -->
        <div class="ev-form-row-2col">
          <div class="ev-form-group">
            <label class="ev-form-group__label">Event Language</label>
            <v-select
              dense
              outlined
              v-model="formData.language"
              :error-messages="errorField.language"
              :items="languages"
              item-text="isoLanguageName"
              item-value="isoLanguageCode"
              placeholder="Select language"
              :menu-props="{
                bottom: true,
                offsetY: true,
              }"
              hide-details="auto"
              class="ev-form-input"
            ></v-select>
          </div>

          <div class="ev-form-group">
            <label class="ev-form-group__label">Status</label>
            <v-select
              dense
              outlined
              :items="statusOptions"
              placeholder="Select status"
              v-model="formData.status"
              :error-messages="errorField.status"
              hide-details="auto"
              class="ev-form-input"
            ></v-select>
          </div>
        </div>

        <!-- Submit -->
        <div class="ev-form-card__actions">
          <button
            class="ev-submit-btn"
            @click="eventDialog = true"
            :disabled="apiSubmit.isLoading"
          >
            <v-icon size="16" color="#fff" class="mr-2">mdi-content-save-outline</v-icon>
            Save Event
          </button>
        </div>
      </div>
    </div>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc_event/objects/globalData";

export default {
  mixins: [hrdcFunction],
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["params"],
  emits: ["toggleEventPage"],
  data: () => ({
    apiSubmit: new Api(),
    apiGetEventCategories: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date3: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu1: false,
    menu2: false,
    menu3: false,
    formData: {
      title: null,
      status: true,
      speakers: [],
      venueAddress: null,
      eventStartDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      eventEndDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      grantApplicationDeadlineDate: null,
      language: "en",
      eventCategory: null,
    },
    errorField: {
      title: null,
      status: null,
      eventStartDate: null,
      eventEndDate: null,
      grantApplicationDeadlineDate: null,
      language: null,
      eventCategory: null,
      speakers: null,
      venueAddress: null,
    },
    loadingDialog: false,
    eventDialog: false,
    editMode: false,
    btnDisabled: false,
    eventType: null,
    statusOptions: [
      {
        text: "Active",
        value: true,
      },
      {
        text: "Inactive",
        value: false,
      },
    ],
    eventCategoriesData: [],
  }),
  async created() {
    this.loadingDialog = !this.loadingDialog;

    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    const eventTypeMap = require("@/services/hrdc_event/eventRegistry").getEventTypeMap();
    this.eventType = eventTypeMap[this.service.key] || null;

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiGetEventCategories: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/settings/event/get-event-categories`,
      },
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/settings/event/create-event`,
        method: "post",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    this.apiGetEventCategories.setQuery(`event_type=${this.eventType}`);
    this.apiGetEventCategories.setCallbackCompleted((response) => {
      try {
        const { status, data } = response;
        if (status) {
          for (const item of data) {
            this.eventCategoriesData.push({
              text: item.category,
              value: item.uuid,
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    });
    this.apiGetEventCategories.fetch();

    //EOC
    this.stages = await this.hrdcData.allStages;
    this.rolesAssignation(this.auth.roles);
    if (!this.isHrdcSuperAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    this.loadingDialog = !this.loadingDialog;
  },
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    addNewEvent() {
      this.eventDialog = !this.eventDialog;
      this.submit();
    },
    toggleEventPage() {
      this.$emit("toggleEventPage", "EventIndex");
    },
    redirectBack() {
      let route = this.eventRoute("Application");
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state[this.service.key].data.viewId,
        },
      });
    },
    async submit() {
      this.showLoadingDialog();

      this.apiSubmit.setParams({
        title: this.formData.title,
        eventStartDate: new Date(this.formData.eventStartDate),
        eventEndDate: new Date(this.formData.eventEndDate),
        grantApplicationDeadlineDate: this.formData.grantApplicationDeadlineDate
          ? new Date(this.formData.grantApplicationDeadlineDate)
          : null,
        status: this.formData.status,
        userUuid: this.auth.uuid,
        eventType: this.eventType,
        speakers: this.formData.speakers,
        venueAddress: this.formData.venueAddress,
        language: this.formData.language,
        eventCategory: this.formData.eventCategory,
      });
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          if (!response.status) {
            this.showErrorMessage(response);
            this.$store.dispatch("showMessage", {
              message: "Please fill in all the required fields",
              messageType: "error",
              timeout: 2000,
            });
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$emit("toggleEventPage", "EventIndex");
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
      this.hideLoadingDialog();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .ev-back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .ev-back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .ev-sub-header__title {
  color: var(--app-text);
}

.dark-mode .ev-form-card {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .ev-form-card__section-label {
  color: var(--app-neutral-fg);
}

.dark-mode .ev-form-card__divider {
  background: var(--app-form-tile);
}

.dark-mode .ev-form-card__actions {
  border-top: 1px solid var(--app-border);
}

.dark-mode .ev-form-group__label {
  color: var(--app-text);
}

.dark-mode .ev-modal {
  background: var(--app-card);
}

.dark-mode .ev-modal__confirm-icon {
  background: var(--app-accent-soft);
}

.dark-mode .ev-modal__heading {
  color: var(--app-text);
}

.dark-mode .ev-modal__message {
  color: var(--app-text-muted);
}

.dark-mode .ev-modal__footer {
  border-top: 1px solid var(--app-border);
}

.dark-mode .ev-modal__btn--outlined {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
  border: 1.5px solid var(--app-border);
}

.dark-mode .ev-modal__btn--outlined:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

/* >>> end auto-dark <<< */

/* ============================================
   ADD WRAPPER (inside tab content)
   ============================================ */
.ev-add-wrap {
  padding: 24px;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ============================================
   SUB-HEADER
   ============================================ */
.ev-sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.ev-sub-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ev-back-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ev-back-btn:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
  transform: translateX(-2px);
}

.ev-sub-header__title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.2px;
}

/* ============================================
   FORM CARD
   ============================================ */
.ev-form-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.ev-form-card__section-label {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ev-form-card__divider {
  height: 1px;
  background: #e2e8f0;
}

.ev-form-card__body {
  padding: 24px;
}

.ev-form-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}

/* ============================================
   FORM GROUPS
   ============================================ */
.ev-form-group {
  margin-bottom: 18px;
}

.ev-form-group__label {
  display: block;
  font-family: 'Lato', sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 6px;
}

.ev-form-row-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* ============================================
   SUBMIT BUTTON
   ============================================ */
.ev-submit-btn {
  display: inline-flex;
  align-items: center;
  padding: 10px 24px;
  border-radius: 10px;
  background: #0ea5e9;
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.2);
}

.ev-submit-btn:hover {
  background: #0284c7;
  box-shadow: 0 4px 16px rgba(14, 165, 233, 0.3);
  transform: translateY(-1px);
}

.ev-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ============================================
   MODAL / DIALOG
   ============================================ */
.ev-modal {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.ev-modal__body {
  padding: 24px;
}

.ev-modal__body--center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 24px;
}

.ev-modal__confirm-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.ev-modal__heading {
  font-family: 'Lato', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 8px;
}

.ev-modal__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

.ev-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
}

.ev-modal__btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 20px;
  border-radius: 10px;
  font-size: 0.84rem;
  font-weight: 700;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
}

.ev-modal__btn--outlined {
  background: #fff;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
}

.ev-modal__btn--outlined:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.ev-modal__btn--primary {
  background: #0ea5e9;
  color: #fff;
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.2);
}

.ev-modal__btn--primary:hover {
  background: #0284c7;
  box-shadow: 0 4px 16px rgba(14, 165, 233, 0.3);
}

/* ============================================
   TRANSITIONS
   ============================================ */
.slide-fade-enter-active { transition: all 0.3s ease; }
.slide-fade-leave-active { transition: all 0.2s ease; }
.slide-fade-enter { transform: translateY(-8px); opacity: 0; }
.slide-fade-leave-to { transform: translateY(-4px); opacity: 0; }

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 768px) {
  .ev-add-wrap { padding: 16px; }
  .ev-form-card__body { padding: 20px 16px; }
  .ev-form-row-2col { grid-template-columns: 1fr; }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .ev-sub-header__title { color: var(--app-text); }
.dark-mode .ev-back-btn { background: var(--app-border); border-color: var(--app-border-strong); }
.dark-mode .ev-back-btn:hover { background: var(--app-border-strong); }
.dark-mode .ev-form-card { background: var(--app-form-tile); border-color: var(--app-border); }
.dark-mode .ev-form-card__section-label { color: var(--app-text-muted); }
.dark-mode .ev-form-card__divider { background: var(--app-border); }
.dark-mode .ev-form-group__label { color: var(--app-neutral-fg); }
.dark-mode .ev-form-card__actions { border-color: var(--app-border); }
.dark-mode .ev-modal { background: var(--app-card); }
.dark-mode .ev-modal__heading { color: var(--app-text); }
.dark-mode .ev-modal__message { color: var(--app-text-muted); }
.dark-mode .ev-modal__footer { border-color: var(--app-border); }

</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .ev-form-input.v-text-field--outlined fieldset {
  border-color: var(--app-field-border) !important;
}

.dark-mode .ev-form-input.v-text-field--outlined:hover fieldset {
  border-color: var(--app-field-border-hover) !important;
}

.dark-mode .ev-form-input input,
.dark-mode .ev-form-input textarea,
.dark-mode .ev-form-input .v-select__selection {
  color: var(--app-text) !important;
}

/* The unscoped `.v-menu__content …` block that used to sit here is gone.
   It was global — unscoped CSS is injected once and never removed, so a rule
   written for THIS page's dropdown repainted every menu in the app (with
   !important, and with hard-coded light hex) for the rest of the session. That
   is what made the same v-select look different depending on which page you had
   visited. Menus are defined ONCE, in tokens, in src/plugins/theme-glass.css §3
   — panel, list, item radius, hover, active, typography and the state overlay.
   A page that genuinely needs its own menu styling should give that v-menu a
   `content-class` and key off it, the way .bdt-menu and .tb-view-menu do. */

.dark-mode .ev-form-input .v-chip {
  background: var(--app-accent-soft) !important;
  /* the background got a dark wash but the label kept the light rule's
     #0369a1, leaving the chip text at 1.77:1 on it */
  color: var(--app-accent-strong) !important;
}

/* >>> end auto-dark <<< */

/* Form input overrides */
/* Vuetify offsets the outlined fieldset to top: -5px so its <legend> can notch
   out the floating label. These fields use a real <label> above the box, so the
   overhang is just an empty band above the content — and any background on
   .v-input__slot stops 5px short of the border, which reads as a gap. Align the
   fieldset with the slot and the band is gone. */
.ev-form-input.v-text-field--outlined fieldset {
  border-color: #e2e8f0 !important;
  border-radius: 10px !important;
  top: 0 !important;
}
.ev-form-input.v-text-field--outlined:hover fieldset {
  border-color: #cbd5e1 !important;
}
.ev-form-input.v-input--is-focused fieldset {
  border-color: #0ea5e9 !important;
  border-width: 2px !important;
}

.ev-form-input .v-input__slot {
  min-height: 42px !important;
}

/* With the fieldset pulled down to top: 0 the border no longer reaches up into
   the label gap, so drop the 4px Vuetify reserves above every field for its
   floating label — .ev-form-group__label owns that spacing. */
.ev-form-input.v-text-field {
  margin-top: 0 !important;
}

.ev-form-input input,
.ev-form-input textarea,
.ev-form-input .v-select__selection {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  color: #1e293b !important;
}

/* Selected chips styling */
.ev-form-input .v-chip {
  background: #e0f2fe !important;
  color: #0369a1 !important;
  border-radius: 6px !important;
  font-family: 'Lato', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  height: 24px !important;
}

.ev-form-input .v-chip .v-chip__close {
  color: #0369a1 !important;
}

.ev-form-input .v-chip .v-chip__close:hover {
  color: #dc2626 !important;
}

/* Error state — red border on invalid inputs */
.ev-form-input.v-input--has-state.error--text fieldset,
.ev-form-input.v-input--has-state.error--text:hover fieldset {
  border-color: #ef4444 !important;
  border-width: 1px !important;
}

.ev-form-input.v-input--has-state.error--text .v-icon {
  color: #ef4444 !important;
}

.ev-form-input .v-messages__message {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  color: #ef4444 !important;
}
.ev-modal-overlay {
  box-shadow: none !important;
  border-radius: 20px !important;
  overflow: hidden;
}

/* >>> dark companions: the light rules above pin these to a dark ink
   with !important, which on the dark field renders the text invisible
   rather than absent. Token references only. <<< */

.dark-mode .ev-form-input input,
.dark-mode .ev-form-input textarea,
.dark-mode .ev-form-input .v-select__selection {
  color: var(--app-text) !important;
}

.dark-mode .ev-form-input .v-chip .v-chip__close {
  color: var(--app-accent-strong) !important;
}

.dark-mode .ev-form-input .v-chip .v-chip__close:hover {
  color: var(--app-danger-fg) !important;
}
</style>
